<template>
  <div>
    <div class="content-header"></div>
    <div class="content-wrapper">
      <el-row>
        <!-- 左边菜单列表 -->
        <el-col :span="6" class="content-left">
          <IndexMenu />
        </el-col>
        <!-- 中间区域 -->
        <el-col :span="13" class="content-center">
          <!-- 中间上部 -->
          <el-card class="content-center-top" shadow="never" >
            <div class="card-title">Menu清单物料下单区域</div>
            <div class="menu-row">
              <router-link to="/material/menu-list">
                <el-card shadow="hover">
                  <div class="card-icon">
                    <i class="iconfont iconzu6" />
                  </div>
                  <div class="card-text">浏览Menu清单</div>
                </el-card>
              </router-link>
              <router-link to="/material/group-list">
                <el-card shadow="hover">
                  <div class="card-icon">
                    <i class="iconfont iconzu4 el-icon-shopping-bag-1" />
                  </div>
                  <div class="card-text">拼单专区</div>
                </el-card>
              </router-link>
              <router-link to="/material/menu-favourite">
                <el-card shadow="hover">
                  <div class="card-icon">
                    <i class="iconfont iconzu7" />
                  </div>
                  <div class="card-text">常用物料快速下单</div>
                </el-card>
              </router-link>
              <router-link to="/material/menu-list-template">
                <el-card shadow="hover">
                  <div class="card-icon">
                    <i class="iconfont iconzu8" />
                  </div>
                  <div class="card-text">上传模版文件</div>
                </el-card>
              </router-link>
            </div>
          </el-card>
          <!-- 中间下部 -->
          <el-card class="content-center-bottom" shadow="never">
            <div class="card-title">Non Menu清单外物料下单区域</div>
            <router-link to="/material/non-menu">
              <el-card shadow="hover" class="card-single cursor">
                <div class="card-icon">
                  <i class="iconfont iconzu11" />
                </div>
                <div class="card-text">Non Menu</div>
              </el-card>
            </router-link>
          </el-card>
        </el-col>
        <!-- 右边区域 -->
        <el-col :span="5" class="content-right">
          <div class="content-right-top">
            <router-link to="/material/printing-list">
              <el-card shadow="hover" class="card-single cursor">
                <div class="card-icon">
                  <i class="iconfont icontupian" style="font-size: 32px" />
                </div>
                <div class="card-text">印刷品</div>
              </el-card>
            </router-link>
          </div>
          <div class="content-right-bottom">
            <router-link to="/stock/index">
              <el-card shadow="hover" class="card-single cursor">
                <div class="card-icon">
                  <i
                    class="iconfont el-icon-box iconzu9"
                    style="font-size: 40px;"
                  />
                </div>
                <div class="card-text">库存管理</div>
              </el-card>
            </router-link>
          </div>
        </el-col>
      </el-row>
    </div>
    <Todo ref="campaign-todo" content="Campaign物料领用与下单模块即将开放。" />
  </div>
</template>

<script>
import IndexMenu from './components/index-menu'
import Todo from '@/components/todo'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'home',
  components: {
    IndexMenu,
    Todo
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    viewCampaign () {
      this.$refs['campaign-todo'].show()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  padding: 0px;
}
.content-header {
  height: 100px;
  background: url("../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  .card-title {
    font-size: $font-14;
  }
  .content-left,
  .content-center,
  .content-right {
    height: 620px;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }
  }
  .content-left,
  .content-center {
    padding-right: $content-middle;
  }
  .content-center-top {
    width: 100%;
    height: 270px;
    margin-bottom: 18px;
    .card-title {
      text-align: center;
      font-weight: 800;
      padding: 15px;
      border-bottom: 1px solid $base-grey2;
    }
    .menu-row {
      display: flex;
      padding-top: $content-middle;
      justify-content: center;
      .el-card {
        width: 140px;
        height: 160px;
        margin: 20px 5px;
        cursor: pointer;
        text-align: center;
        .card-icon {
          padding: 50px 0 10px 0;
          margin-bottom: $content-middle;
          .iconfont {
            font-size: 36px;
            transition: all 0.4s;
          }
        }
        .card-text {
          font-size: $font-14;
        }
      }
      .el-card:nth-child(2) {
        margin: 0 $content-large;
      }
    }
  }
  .content-center-bottom {
    .card-title {
      text-align: center;
      font-weight: 800;
      padding: 15px;
      border-bottom: 1px solid $base-grey2;
    }
    .el-card {
      height: 220px;
      margin:30px 15px;
      .card-title {
        text-align: center;
      }
      .cam-row {
        height: 180px;
        margin-top: 40px;
        .cam-col {
          width: 50%;
          height: 100%;
          display: inline-block;
          box-sizing: border-box;
          text-align: center;
          .card-icon {
            padding: 35px 0 6px 0;
            margin-bottom: $content-middle;
            .iconfont {
              font-size: 38px;
              transition: all 0.4s;
            }
          }
        }
      }
    }
    .el-col:not(:first-child) {
      padding-left: $content-middle;
    }
  }
}

.card-single {
  text-align: center;
  .card-icon {
    padding: 80px 0 8px 0;
    margin-bottom: $content-middle;
    .iconfont {
      font-size: 36px;
      transition: all 0.4s;
    }
  }
}
.content-right {
  .content-right-top {
    margin-bottom: 20px;
    .card-single {
      height: 270px;
      .card-icon {
      padding-top: 110px;
    }
    }
  }
  .content-right-bottom {
   .card-single {
      height: 330px;
      .card-icon {
      padding-top: 130px;
    }
    }
  }
}

.iconzu4 {
  color: $base-brown;
}
.iconzu6 {
  color: $base-red;
}
.iconzu7 {
  color: $base-yellow;
}
.iconzu8 {
  color: $base-pink;
}
.iconzu10 {
  color: $base-yellow;
}
.iconzu9 {
  color: $base-olive;
}
.icontupian {
  color: $base-blue;
}
.iconzu11 {
  color: $base-teal;
}
</style>
